import { Dispatch, SetStateAction } from "react";
import { UseFormRegister } from "react-hook-form";
import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { useGetProdutosTipo } from "../../hooks/useGetProdutosTipo";
import { ProdutoModulo } from "../../types/Produto";
import { ProdutoTipo } from "../../types/ProdutoTipo";

interface ProdutoModalProps {
  produto?: ProdutoModulo
  visualizar?: boolean
  inputDisabled?: boolean
  errors: any
  register: UseFormRegister<any>
  setInputDisabled?: Dispatch<SetStateAction<boolean>>
}

export function FormProduto({
  inputDisabled,
  visualizar,
  produto,
  register,
  errors
} : ProdutoModalProps) {
  const { data : tipoProduto } = useGetProdutosTipo()
  
  const options = (items : ProdutoTipo) => {
    return <option
      selected = { items?.ProdutoTipoId === produto?.ProdutoTipoId} 
      className="input-login-style w-full mb-5"
      key={produto?.ProdutoTipoId ? produto?.ProdutoTipoId : items?.ProdutoTipoId}
      value={Number(items?.ProdutoTipoId )}
    >
      <>
      {items?.Nome}
      </>
    </option>
  };
  
  return (
    <form className="flex flex-row flex-wrap justify-around items-center">
      {
        visualizar && !produto ? <div className="h-[20rem] flex items-center justify-center"><LoadingPage /></div> :
        <>
          <div className="w-[40%]">
            <label className=" w-full font-[500]" htmlFor="Nome">
              Nome do Produto
              <span className="text-red-500">*</span>
            </label>
            <input 
              type="text"
              {...register("Nome", {required: errors ? true : false})}
              defaultValue={produto?.Nome}
              disabled={inputDisabled}
              name="Nome"
              maxLength={50}
              className={`input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] ${errors ? 'focus:border-red-500' : 'none'}`}
            />
          </div>
          <div className="w-[40%]">
            <label className="font-[500]" htmlFor="CodigoFornecedor">CodigoABS</label>
            <input 
              type="text"
              {...register("CodigoFornecedor")}
              defaultValue={produto?.CodigoFornecedor}
              disabled={inputDisabled}
              name="CodigoFornecedor"
              maxLength={50}
              className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            />
          </div>
          <div className="w-[40%]">
            <label className="font-[500]">Tipo do Produto</label>
            <select 
              className="border p-2 w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
              {...register("ProdutoTipoId")}
              name="ProdutoTipoId"
              disabled={inputDisabled}
            >
              {tipoProduto?.map(options)}
            </select>
          </div>
          <div className="w-[40%]">
            <label className="font-[500]" htmlFor="TouroRaca">Raça do Touro</label>
            <input 
              type="text"
              {...register("TouroRaca")}
              defaultValue={produto?.TouroRaca}
              disabled={inputDisabled}
              name="TouroRaca"
              maxLength={50}
              className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            />
          </div>
          <div className="w-[40%]">
            <label className="font-[500]" htmlFor="TouroRack">Rack</label>
              <input 
                type="text"
                {...register("TouroRack")}
                defaultValue={produto?.TouroRack}
                disabled={inputDisabled}
                name="TouroRack"
                maxLength={50}
                className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
                />
          </div>
          <div className="w-[40%]">
            <label className="font-[500]" htmlFor="TouroSemenTipo">Tipo do Semen</label>
            <input
              type="text"
              {...register("TouroSemenTipo")}
              defaultValue={produto?.TouroSemenTipo}
              disabled={inputDisabled}
              name="TouroSemenTipo"
              maxLength={50}
              className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            />
          </div>
          <div className="text-red-500">Os campos com * são obrigatórios</div>
        </>
      }
    </form>
  );
}
